import * as React from "react";
import PropTypes from "prop-types";
import {
  Eye16Filled,
  Certificate16Regular,
  ListBar16Filled,
  TableSimple16Regular,
  MoreHorizontal16Regular,
  MoreVertical16Filled,
} from "@fluentui/react-icons";
import {
  Label,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemLink,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Tooltip,
  Image,
  Text,
  Link,
  tokens,
  makeStyles,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
  Button,
  typographyStyles,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  component: {
    paddingRight: tokens.spacingHorizontalM,
  },
  tools: {
    marginBottom: tokens.spacingVerticalM,
    textAlign: "right",
  },
  cards: {
    marginBottom: tokens.spacingVerticalM,
  },
  card: {
    marginBottom: tokens.spacingVerticalM,
  },
  cardPreview: {
    paddingLeft: tokens.spacingVerticalM,
    paddingRight: tokens.spacingVerticalM,
  },
  toolsButton: {
    marginLeft: tokens.spacingHorizontalSNudge,
  },
  label: {
    display: "block",
    color: tokens.colorBrandStroke1,
    fontWeight: tokens.fontWeightBold,
  },
  text: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    marginRight: tokens.spacingHorizontalSNudge,
  },
  textBlock: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    display: "block",
  },
  textLink: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },
  textLinkStrong: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
});

const Quote = (props) => {
  const { data, domain, loading } = props;
  const styles = useStyles();

  return (
    <section className={styles.component}>
      {loading == false ? (
        data && data.length ? (
          <div className={styles.cards}>
            {data.map((quote) => {
              return (
                <Card className={styles.card} key={quote.Quote.id}>
                  <CardHeader
                    header={
                      <Link
                        href={`${domain}/admin/quotes/view/${quote.Quote.id}`}
                        target="_blank"
                        className={styles.textLinkStrong}
                      >
                        #{quote.Quote.id}
                      </Link>
                    }
                    action={
                      <div>
                        <Text className={styles.text}>{new Date(quote.Quote.created).toLocaleString()}</Text>
                        <Menu>
                          <MenuTrigger disableButtonEnhancement>
                            <MenuButton icon={<MoreVertical16Filled />} size="small" appearance="transparent" />
                          </MenuTrigger>
                          <MenuPopover>
                            <MenuList>
                              <MenuItemLink
                                icon={<Eye16Filled />}
                                href={`${domain}/admin/quotes/view/${quote.Quote.id}`}
                                target="_blank"
                              >
                                View
                              </MenuItemLink>
                            </MenuList>
                          </MenuPopover>
                        </Menu>
                      </div>
                    }
                  />
                  <CardPreview className={styles.cardPreview}>
                    {quote.ProductQuote.map((productQuote) => {
                      return (
                        <Text className={styles.text} key={productQuote.product_id}>
                          {productQuote.quantity} x {productQuote.product_title}
                        </Text>
                      );
                    })}
                  </CardPreview>
                  <CardFooter>
                    <div>
                      <Label size="small" weight="semibold" className={styles.label}>
                        Type
                      </Label>
                      <Text className={styles.text}>{quote.Quote.type}</Text>
                    </div>
                  </CardFooter>
                </Card>
              );
            })}
          </div>
        ) : (
          <Text>No quotes found</Text>
        )
      ) : (
        <Text>Loading...</Text>
      )}
    </section>
  );
};

Quote.propTypes = {
  query: PropTypes.object,
};

export default Quote;
